import { useState } from 'react';
import { Button, DialogActions } from '@mui/material';

export default function ResponsiveDialogActions({
  onAccept,
  onReject,
  acceptText = 'تائید',
  rejectText = 'انصراف',
  acceptDisable = false,
  singleAction = false,
  acceptButtonProps = {}, // Allow custom props from parent
  rejectButtonProps = {}, // Allow custom props from parent
}) {
  const [loading, setLoading] = useState(false);

  async function handleAccept() {
    setLoading(true);
    try {
      await onAccept();
    } finally {
      setLoading(false);
    }
  }

  return (
    <DialogActions
      sx={{
        direction: 'rtl',
        display: 'flex',
        justifyContent: 'space-between',
        gap: 2,
        px: 0,
        pt: 5,
      }}
    >
      <Button
        variant="outlined"
        disabled={loading}
        onClick={onReject}
        sx={{
          minWidth: '100px',
          width: { xs: singleAction ? '100%' : '50%', md: 'initial' },
          py: 1.5,
          borderRadius: '12px',
          borderColor: '#f43f5e',
          color: '#f43f5e',
          fontWeight: 600,

          transition:
            'border-color 0.3s ease, color 0.3s ease, box-shadow 0.3s ease, transform 0.2s ease',
          '&:hover': {
            borderColor: '#e11d48',
            color: '#e11d48',
            backgroundColor: 'rgba(244, 63, 94, 0.05)',
          },
          '&:disabled': {
            borderColor: 'rgba(244, 63, 94, 0.5)',
            color: 'rgba(244, 63, 94, 0.5)',
            boxShadow: 'none',
          },
          ...rejectButtonProps.sx,
        }}
      >
        {rejectText}
      </Button>

      {!singleAction && (
        <Button
          variant="contained"
          disabled={acceptDisable || loading}
          onClick={handleAccept}
          sx={{
            minWidth: '100px',
            width: { xs: '50%', md: '80%' },
            py: 1.5,
            borderRadius: '12px',
            background: 'linear-gradient(45deg, #2dd4bf, #14b8a6)',
            color: '#fff',
            fontWeight: 600,
            transition:
              'background 0.3s ease, box-shadow 0.3s ease, transform 0.2s ease',
            '&:hover': {
              background: 'linear-gradient(45deg, #2dd4bf, #14b8a6)',
            },
            '&:disabled': {
              background: 'rgba(16, 185, 129, 0.5)',
              color: '#fff',
              boxShadow: 'none',
            },
            ...acceptButtonProps.sx,
          }}
        >
          {acceptText}
        </Button>
      )}
    </DialogActions>
  );
}
